export default {
  "organization": {
    "title": "Como Estamos Organizados",
    "description": "A marca Cafés da Região Vulcânica é regulamentada, controlada e protegida pela:",
    "association_name": "Associação dos Produtores do Café da Região Vulcânica",
    "about": "Somos uma organização sem fins lucrativos, de caráter representativo, formada por membros e parcerias voltadas ao desenvolvimento da cafeicultura regional.",
    "purpose_title": "Nosso Propósito",
    "purpose_description": "Nosso objetivo é criar percepção e pertencimento, indo além da qualidade, criando oportunidades reais e transformando a maneira com que produzimos, comercializamos, valorizamos e consumimos o nosso café dentro e fora da região.",
    "image_src": "/images/organization/q-org.png"
  }
}
